<template>
  <div class="calendar-table-container">
    <el-calendar v-model="value">
      <template v-slot:dateCell="{data}">
        <div class="calendar-text" :class="data.isSelected ? 'is-selected' : ''">
          <div class="calendar-text-date">{{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : ''}}{{'（文件数量）'}}</div>
          <div class="calendar-text-system">{{`系统：${systemList[data.day]||0}`}}</div>
          <div class="calendar-text-api">{{`openApi：${openApiList[data.day]||0}`}}</div>
          <i v-if="data.isSelected&&(systemList[data.day]||openApiList[data.day])" @click.stop="showDialog(data.day)" class="el-icon-view icon-view" title="查看当前日期文件"></i>
        </div>
      </template>
    </el-calendar>
    <!-- 对话框 -->
    <el-dialog class="calendar-table-dialog" :title="dialog.title" :visible.sync="dialog.visible" :before-close="destroyComponent" fullscreen :modal="false">
      <component :is="dialog.component" @close="destroyComponent" :date="date" />
    </el-dialog>
  </div>
</template>

<script>
import { fileManageApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import { dialogMixin } from "@/common/mixins/";
import dayjs from 'dayjs';
import LocalFileDialog from './localFileDialog.vue';
export default {
  name: 'calendar-table',
  mixins: [dialogMixin],
  data () {
    return {
      value: '',
      systemList: {},
      openApiList: {}
    }
  },
  computed: {
    yearMonth () {
      return this.formatTime(this.value, 'YYYY-MM');
    },
    date () {
      return this.formatTime(this.value, 'YYYY-MM-DD');
    }
  },
  watch: {
    yearMonth (val) {
      this.findCalendarFileCount();
    }
  },
  mounted () {
    this.value = new Date();
  },
  methods: {
    // 查询文件数量
    async findCalendarFileCount () {
      showLoading();
      const res = await fileManageApi.findCalendarFileCount({ time: this.yearMonth });
      if (res.code === 200) {
        this.systemList = this.keysMapping(res.data.systemList, 'time', 'fileCount');
        this.openApiList = this.keysMapping(res.data.openApiList, 'time', 'fileCount');
      } else {
        this.$message.error(res.message);
      }
      hideLoading();
    },
    // 格式化时间
    formatTime (time, format) {
      return dayjs(time).format(format || 'YYYY-MM-DD HH:mm:ss');
    },
    // 按日期格式化数据
    keysMapping (data = [], key, val) {
      if (!key && !val) return;
      const obj = {};
      data.forEach(item => {
        obj[item[key]] = item[val];
      })
      return obj;
    },
    // 销毁动态组件
    destroyComponent () {
      this.setDialog(false, "", null, "1100px", "1vh");
    },
    showDialog (date) {
      this.setDialog(true, date, LocalFileDialog);
    }
  }
}
</script>

<style lang="scss">
.calendar-table-container {
  .calendar-table-dialog {
    .el-dialog {
      border-radius: 0 !important;
    }
  }
  .calendar-text {
    position: relative;
    font-weight: 500;
    &-date {
      font-size: 12px;
      margin-bottom: 10px;
    }
    .icon-view {
      position: absolute;
      right: 14px;
      top: 24px;
      font-weight: 700;
      color: #606266;
      font-size: 24px;
      &:hover {
        color: #1989fa;
      }
    }
  }
  .is-selected {
    font-weight: 700;
    color: #1989fa;
  }
}
</style>